import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-937fd7d6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "view-wrapper"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "text"
};
var _hoisted_4 = {
  class: "info"
};
var _hoisted_5 = {
  class: "info"
};
var _hoisted_6 = {
  class: "retry-container"
};
import { onMounted, onBeforeUnmount, ref, computed } from "vue";
import { preventAppRefresh, allowAppRefresh } from "@/utils/vue-helpers/log";
import { LogService } from "@/services/logging";
import { ComplianceErrorCodes, initializeComplianceLib, testFdmConnection, testEfrConnection } from "@/utils/helpers/compliance";
import ComplianceModule from "@/store/modules/compliance";
import { LocalStorageKeys } from "@/services/storage.service";
import { syncDeviceLocation } from "@/utils/helpers/device";
import DeviceModule from "@/store/modules/device";
import POSConfigModule from "@/store/modules/pos-config";
import i18n from "@/lang";
export default /*#__PURE__*/_defineComponent({
  __name: 'SellingDisabled',
  setup: function setup(__props) {
    var refreshingComplianceStatus = ref(false);
    var hardwareUid = computed(function () {
      var _DeviceModule$hardwar;

      return DeviceModule.getHardwareHash || localStorage.getItem(LocalStorageKeys.manualHardwareUuid) || ((_DeviceModule$hardwar = DeviceModule.hardwareInfo) === null || _DeviceModule$hardwar === void 0 ? void 0 : _DeviceModule$hardwar.id) || "Unknown";
    });
    var salesDisabledText = computed(function () {
      if (POSConfigModule.getGroupCountryCode === "BE") {
        return i18n.global.t("compliance.sales-disabled-content-belgium)");
      }

      return i18n.global.t("compliance.sales-disabled-content");
    });
    var errorCodes = computed(function () {
      var _DeviceModule$hardwar2;

      var codes = [];
      var _ComplianceModule$com = ComplianceModule.complianceStatus,
          packageInit = _ComplianceModule$com.packageInit,
          fdmConnection = _ComplianceModule$com.fdmConnection,
          efrConnection = _ComplianceModule$com.efrConnection;

      if (!packageInit) {
        codes.push(ComplianceErrorCodes.COMPLIANCE_LIB_INIT_FAILED);
      }

      if (!fdmConnection && POSConfigModule.getGroupCountryCode === "BE") {
        codes.push(ComplianceErrorCodes.FDM_NOT_CONNECTED);
      }

      if (!efrConnection && POSConfigModule.getGroupCountryCode === "ES") {
        codes.push(ComplianceErrorCodes.EFR_NOT_CONNECTED);
      }

      if (!((_DeviceModule$hardwar2 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar2 !== void 0 && _DeviceModule$hardwar2.deviceUid)) {
        codes.push(ComplianceErrorCodes.DEVICE_NOT_ASSIGNED);
      }

      if (!codes.length) {
        codes.push(ComplianceErrorCodes.UNKNWON_ERROR);
      }

      return codes.join(", ");
    });
    onMounted(function () {
      // allow aborting recovery after 90 seconds
      LogService.info("Disabled sales view mounted", {
        errorCodes: errorCodes
      });
      preventAppRefresh();
    });
    onBeforeUnmount(function () {
      LogService.info("Disabled sales view unmounted");
      allowAppRefresh();
    });

    function refreshComplianceStatus() {
      return _refreshComplianceStatus.apply(this, arguments);
    }

    function _refreshComplianceStatus() {
      _refreshComplianceStatus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ComplianceModule$com2, packageInit, fdmConnection, efrConnection;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                refreshingComplianceStatus.value = true;
                _ComplianceModule$com2 = ComplianceModule.complianceStatus, packageInit = _ComplianceModule$com2.packageInit, fdmConnection = _ComplianceModule$com2.fdmConnection, efrConnection = _ComplianceModule$com2.efrConnection; // Check and sync device location if needed

                _context.next = 4;
                return syncDeviceLocation();

              case 4:
                if (packageInit) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 5;
                _context.next = 8;
                return initializeComplianceLib();

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](5);
                LogService.info("Failed to initialize compliance lib", {
                  error: _context.t0
                });

              case 13:
                if (fdmConnection) {
                  _context.next = 16;
                  break;
                }

                _context.next = 16;
                return testFdmConnection();

              case 16:
                if (efrConnection) {
                  _context.next = 25;
                  break;
                }

                _context.prev = 17;
                _context.next = 20;
                return testEfrConnection();

              case 20:
                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t1 = _context["catch"](17);
                LogService.info("Failed to check EFR connection", {
                  error: _context.t1
                });

              case 25:
                refreshingComplianceStatus.value = false;

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 10], [17, 22]]);
      }));
      return _refreshComplianceStatus.apply(this, arguments);
    }

    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("compliance.sales-disabled")), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(salesDisabledText.value), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("compliance.error-codes")) + ": " + _toDisplayString(errorCodes.value), 1), _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("complaince.hardware-uid")) + ": " + _toDisplayString(hardwareUid.value), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: refreshComplianceStatus,
        loading: refreshingComplianceStatus.value
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("label.refresh")), 1)];
        }),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});